import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/wizard/:id',
      name: 'Wizard',
      component: () => import('../components/Wizard.vue'),
    },
    {
      path: '/location',
      name: 'Location',
      component: () => import('../views/Location.vue'),
    },
    {
      path: '/result',
      name: 'Result',
      component: () => import('../views/Result.vue'),
    },
    {
      path: '/details/:id',
      name: 'Details',
      component: () => import('../views/Details.vue'),
    },
    {
      path: '/save',
      name: 'Save',
      component: () => import('../views/Save.vue'),
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/404.vue'),
    },
    {
      path: '/*',
      name: 'MissingPage',
      component: () => import('../views/404.vue'),
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
